import { AxiosInstance } from 'axios';
import { IBaseService, BaseService } from './BaseServiceClass';
import { IOrganization, ResponseOrganizationLicense } from 'types/models/OrganizationModels';
import { IResult } from './Result';

export interface IOrganizationService extends IBaseService<IOrganization> {
  getLicenseTypes(): Promise<ResponseOrganizationLicense>;
}

export class OrganizationService extends BaseService<IOrganization> implements IOrganizationService {
  constructor(axiosInstance: AxiosInstance) {
    super(axiosInstance, 'api/organizations');
  }

  getLicenseTypes = async (): Promise<ResponseOrganizationLicense> => {
    const response = await this._axiosInstance.get<IResult<ResponseOrganizationLicense>>(`${this._baseEndpoint}/licenses`);

    if (response.data && !response.data.isError && response.data.data) {
      return response.data.data;
    }
    throw Error(
      response.status === 500 ? 'There was an internal error while fetching the License Types.' : response.data.toString()
    );
  }
}